var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-pallets"},[_c('v-header',{attrs:{"user":_vm.user}}),_c('pallets-list',{attrs:{"user":_vm.user,"selectable":true,"changeableStatus":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }